const env = process.env.VUE_APP_ENV;

let envApiUrl = '';
let envPlannerAppUrl = '';
let envGapiKey = '';
let envGapiClientId = '';

// Staging == Production at the moment
if ((env === 'production') || (env === 'staging')) {
  envApiUrl = process.env.NODE_ENV === 'development' ? '' : `https://${process.env.VUE_APP_DOMAIN_PROD}`;
  envPlannerAppUrl = `https://planner.${process.env.VUE_APP_DOMAIN_PROD}`;
  envGapiKey = 'AIzaSyAI8rd_eiGEZQO7eKa0WAzqkmb01027zTI'
  envGapiClientId = '1088215712282-itldv82d9ma58u1giq79avvpm5pj07pr.apps.googleusercontent.com'
} else if (env === 'qa') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_QA}`;
  envPlannerAppUrl = `https://planner.${process.env.VUE_APP_DOMAIN_QA}`;
  envGapiKey = 'AIzaSyAI8rd_eiGEZQO7eKa0WAzqkmb01027zTI'
  envGapiClientId = '1088215712282-itldv82d9ma58u1giq79avvpm5pj07pr.apps.googleusercontent.com'
} else if (env === 'prod-k8s') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_PROD_K8S}`;
  envPlannerAppUrl = `https://planner.${process.env.VUE_APP_DOMAIN_PROD_K8S}`;
  envGapiKey = 'AIzaSyAI8rd_eiGEZQO7eKa0WAzqkmb01027zTI'
  envGapiClientId = '1088215712282-itldv82d9ma58u1giq79avvpm5pj07pr.apps.googleusercontent.com'
} else {
  envApiUrl = `http://${process.env.VUE_APP_DOMAIN_DEV}`;
  envPlannerAppUrl = `https://planner.${process.env.VUE_APP_DOMAIN_DEV}`;
  envGapiKey = 'AIzaSyDGb9YdxEO6NYVAUAE8OgGU0F2Qw9uMSaA'
  envGapiClientId = '608363180622-9s8614d27j04m1j5o5gibiuu9dg0ha5o.apps.googleusercontent.com'
}

export const apiUrl = envApiUrl;
export const plannerAppUrl = envPlannerAppUrl;
export const gapiKey = envGapiKey;
export const gapiClientId = envGapiClientId;
export const appName = process.env.VUE_APP_NAME;
